"use client";

import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ServiceSlider from "./components/ServiceSlider";
import TrustBar from "./components/TrustBar";
import ServicesBento from "./components/ServicesBento";
import SMBPainPointsSection from "./components/SMBPainPointsSection";
import InfrastructureSection from "./components/InfrastructureSection";
import CyberSection from "./components/CyberSection";
import AIAutomationSection from "./components/AIAutomationSection";
import SocialProofSection from "./components/SocialProofSection";
import CtaSection from "./components/CtaSection";
import StickyCTA from "./components/StickyCTA";

export default function HomePageContent() {
  return (
    <main style={{ background: "#070B14", overflowX: "hidden" }}>
      <Header />
      <StickyCTA />
      <ServiceSlider />
      <TrustBar />
      <ServicesBento />
      <SMBPainPointsSection />
      <InfrastructureSection />
      <CyberSection />
      <AIAutomationSection />
      <SocialProofSection />
      <CtaSection />
      <Footer />
    </main>
  );
}
